<ng-container *ngrxLet="data$ as data">
  @if (data.options?.filtersToolbar && !data.options?.rocksQuickFilters) {
    <mat-toolbar
      color="accent"
      id="filters-toolbar"
      class="terrafy-filters-toolbar"
      [class.is-meeting]="isMeeting()"
      [class.is-feedback]="isFeedback"
      [class.is-meeting-nav-collapsed]="meetingNavCollapsed()"
      [ngClass]="(filterService.sideNavExpanded$ | async) ? 'expanded' : 'collapsed'"
      [class.is-meeting-rocks]="isMeeting() && data.options?.rockStatusDropdown"
      [class.show-responsive-filters]="data.showResponsiveFilters"
      [class.hide-responsive-filters]="!data.showResponsiveFilters">
      @if (meetingNavCollapsed()) {
        <button
          type="button"
          class="meeting-nav-expand-toggle brand-colored"
          [class.brand-light]="data.brandIsLight"
          aria-label="Expand meeting navigation"
          (click)="expandMeetingNav()"
          [ninetyTooltip]="'Expand'"
          tpPlacement="right">
          <terra-icon icon="caret-right" variant="bold" size="12" />
        </button>
      }
      @if (data.options?.showTitle) {
        <h3 attr.data-cy="filters-toolbar_title-{{ data.options?.title }}">
          {{ data.options?.title }}
        </h3>
      }
      @if (!data.options?.showTitle) {
        <div class="all-filters">
          <div class="static-filters">
            @if (data.options?.toolbarDescriptor?.length) {
              <h3 class="app-name">
                {{ data.options.toolbarDescriptor }}
              </h3>
            }
            @if (data.options?.teamDropdown && !data.isLiteUser) {
              <terra-quick-filter
                key="Team"
                data-cy="filters-toolbar_team-select"
                [ngModel]="data.selectedTeam"
                (selectionChange)="selectTeam($event)"
                [compareWith]="teamsAreSame"
                [disabled]="data.isFetchingData"
                maxHeight="450">
                <terra-search-input
                  data-cy="filters-toolbar_team-search"
                  [(ngModel)]="teamSearchVal"
                  placeholder="Search for teams..."
                  (ngModelChange)="onSearchChanged($event)" />
                @if (
                  !data.filteredTeams ||
                  data.filteredTeams.length === 0 ||
                  (data.filteredTeams.length === 1 && data.filteredTeams[0].dontShowInResults)
                ) {
                  <terra-description>
                    No search results found. Please check your<br />
                    spelling or try a different search.
                  </terra-description>
                }
                @for (team of data.filteredTeams | terraLazyOptions; track trackById($index, team)) {
                  <terra-option
                    attr.data-cy="filters-toolbar_option-{{ team.name }}"
                    [value]="team"
                    [disabled]="data.options.filterOutProjectTeams && team.project"
                    [style.display]="data.searchTerm && team.dontShowInResults ? 'none' : 'block'">
                    {{ team.name }}
                    <span *terraOptionSuffix>
                      {{ data.options.filterOutProjectTeams && team.project ? 'Project' : '' }}
                    </span>
                  </terra-option>
                }
              </terra-quick-filter>
            }
            @if (data.options?.personDropdown && data.isManagerOrAbove) {
              <terra-quick-filter
                key="Person"
                data-cy="filters-toolbar_select-person"
                [ngModel]="data.selectedUserId"
                (selectionChange)="filterService.setUserId($event)"
                maxHeight="350">
                <terra-option data-cy="filters-toolbar_all-option" value="all">
                  <terra-icon *terraOptionPrefix icon="users" />
                  All
                </terra-option>
                @for (
                  user of userService.allUsersAndImplementers
                    | filterUsersByRole: RoleCode.observer : true
                    | sortByUserName;
                  track trackById($index, user)
                ) {
                  <terra-option
                    attr.data-cy="filters-toolbar_user-name-{{ user | displayNameOrEmail }}"
                    [value]="user._id">
                    <terra-avatar
                      *terraOptionPrefix
                      [src]="user?.metadata?.picture?.url"
                      [initials]="user | userInitials"
                      [inactive]="!user.active" />
                    {{ user | displayNameOrEmail }}
                  </terra-option>
                }
              </terra-quick-filter>
            }
            @if (data.options.ownerDropdown) {
              <terra-quick-filter
                [ngModel]="data.selectedUserId"
                (selectionChange)="filterService.setOwnerId($event)"
                key="Person"
                maxHeight="350">
                <terra-option value="all"> <terra-icon *terraOptionPrefix icon="users" />All</terra-option>
                @for (user of userService.allUsersAndImplementers | sortByUserName; track user._id) {
                  <terra-option [value]="user._id">
                    <terra-avatar
                      *terraOptionPrefix
                      [src]="user.metadata?.picture?.url"
                      [initials]="user | userInitials" />
                    {{ user | displayNameOrEmail }}
                  </terra-option>
                }
              </terra-quick-filter>
            }
            <div class="fill-remaining-space"></div>
          </div>
          <div class="responsive-filters">
            @if (data.options?.userStatusDropdown) {
              <terra-quick-filter
                key="Persons"
                data-cy="filters-toolbar_user-status-dropdown"
                [ngModel]="data.selectedUserStatusId"
                (selectionChange)="filterService.setUserStatusId($event)">
                <terra-option data-cy="filters-toolbar_option-all" [value]="DirectoryUserStatus.all">All</terra-option>
                <terra-option data-cy="filters-toolbar_option-paid" [value]="DirectoryUserStatus.paid"
                  >Paid Users</terra-option
                >
                <terra-option data-cy="filters-toolbar_option-invited" [value]="DirectoryUserStatus.invited"
                  >Invited Users</terra-option
                >
                <terra-option data-cy="filters-toolbar_option-pending" [value]="DirectoryUserStatus.pending"
                  >Pending Users</terra-option
                >
                <terra-option data-cy="filters-toolbar_option-not-invited" [value]="DirectoryUserStatus.notInvited"
                  >Not Invited</terra-option
                >
              </terra-quick-filter>
            }
            @if (data.options?.vtoToggle && data.teamVto && data.isManagerOrAbove && data.isSlt) {
              <terra-switch
                class="vto-cascade-toggle"
                [ngModel]="data.teamVto.isSharing"
                (change)="vtoService.update(data.teamVto._id, { isSharing: $event }, true).subscribe()"
                matTooltip="Share {{ data.language?.vto?.item }} with All Teams"
                matTooltipPosition="above"
                matTooltipClass="ninety-tooltip">
                Share {{ data.language?.vto?.item }} with All Teams
              </terra-switch>
            }
            @if (data.options?.vtoToggle && data.teamVto && !data.isSlt && data.sltVto?.isSharing) {
              <terra-switch
                class="vto-cascade-toggle"
                [ngModel]="vtoService.viewingSltVto"
                (change)="vtoService.toggleSltVto()"
                [disabled]="data.isFetchingData"
                matTooltip="View Leadership {{ data.language?.vto?.item }}"
                matTooltipPosition="above"
                matTooltipClass="ninety-tooltip">
                View Leadership {{ data.language?.vto?.item }}
              </terra-switch>
            }
            @if (data.options?.showCompletedConversations) {
              <terra-switch
                data-cy="filters-toolbar_show-completed-conversations-toggle"
                class="completed-conversations-toggle"
                [ngModel]="showCompletedConversations$ | async"
                (change)="filterService.onShowCompletedConversations()"
                [disabled]="data.isFetchingData"
                matTooltip="Show completed {{ data.language?.feedback?.items }}"
                matTooltipPosition="above"
                matTooltipClass="ninety-tooltip">
                Show completed
              </terra-switch>
            }
            <div class="archive-copy">
              @if (data.options?.archiveCopy && data.teamVto) {
                <button
                  data-cy="filters-toolbar_archive-copy-menu-button"
                  aria-label="Archive menu"
                  class="center-content"
                  mat-button
                  [matMenuTriggerFor]="archiveCopyMenu"
                  [disabled]="data.isFetchingData">
                  <terra-icon icon="archive" />
                  Archive
                </button>
              }
            </div>
            <mat-menu #archiveCopyMenu="matMenu">
              @if (data.isManagerOrAbove) {
                <button
                  data-cy="filters-toolbar_archive-copy-menu-item"
                  mat-menu-item
                  [class.orange]="!data.isFetchingData && !data.archivedVto && !vtoService.viewingSltVto"
                  (click)="filterService.archiveCopy$.next(null)"
                  [disabled]="data.isFetchingData || !!data.archivedVto || vtoService.viewingSltVto">
                  <terra-icon icon="archive" />
                  <span>Archive a copy of this {{ data.language?.vto?.item }}</span>
                </button>
              }
              <button
                data-cy="filters-toolbar_view-archived-menu-item"
                mat-menu-item
                [matMenuTriggerFor]="archivedVtos"
                [disabled]="!data.teamVto?.archivedVtoIds?.length">
                View Archived {{ data.language?.vto?.items }}
              </button>
            </mat-menu>
            <mat-menu #archivedVtos="matMenu">
              @for (archivedObjectId of data.teamVto?.archivedVtoIds; track archivedObjectId) {
                <button
                  attr.data-cy="filters-toolbar_archived-vision-{{
                    helperService.getCreatedDate(archivedObjectId) | date: 'mediumDate' : undefined : locale
                  }}"
                  mat-menu-item
                  class="archive-btn"
                  (click)="vtoService.getArchivedVto(archivedObjectId)"
                  [class.selected-vto]="data.archivedVto?._id === archivedObjectId"
                  matTooltip="View this Archived {{ data.language?.vto?.item }}"
                  matTooltipPosition="above"
                  matTooltipClass="ninety-tooltip">
                  @if (data.archivedVto?._id !== archivedObjectId) {
                    <terra-icon icon="show" />
                  }
                  @if (data.archivedVto?._id === archivedObjectId) {
                    <terra-icon icon="check" class="orange" />
                  }
                  <span class="archived-date">
                    {{ helperService.getCreatedDate(archivedObjectId) | date: 'mediumDate' : undefined : locale }}
                  </span>
                  <span class="fill-remaining-space"></span>
                  @if (data.isManagerOrAbove) {
                    <terra-icon
                      icon="delete"
                      class="red right-space-0"
                      ninetyStopPropagation
                      (click)="vtoService.removeArchivedVto(archivedObjectId)"
                      matTooltip="Delete this Archived {{ data.language?.vto?.item }}"
                      matTooltipPosition="above"
                      matTooltipClass="ninety-tooltip" />
                  }
                </button>
              }
            </mat-menu>
            @if (data.archivedVto) {
              <button mat-button (click)="vtoService.viewTeamVto()" [disabled]="data.isFetchingData">
                <terra-icon icon="undo" />
                <span>View your team {{ data.language?.vto?.item }}</span>
              </button>
            }
            <!-- This is visible on rock page in meetings or in to-dos page, that's the reason for checking export type -->
            @if (
              (data.options?.showTeamOwnersFilterDropdown && data.usersFilterOptions && !data.isIssuesTrashView) ||
              data.options?.excelExportType === ExcelExportType.teamTodo ||
              (data.options?.headlinesMoreActionsBtn && data.isHeadlinesTrashView && data.usersFilterOptions) ||
              (data.options?.issuesMoreActionsBtn && data.isIssuesTrashView && data.usersFilterOptions)
            ) {
              <terra-quick-filter
                data-cy="filters-toolbar_user-select"
                key="Owner"
                maxHeight="350"
                [ngModel]="data.selectedUsersFilterOptions"
                [compareWith]="compareUsers"
                (selectionChange)="filterByUsers($event)"
                (openedChange)="onUsersDropdownOpened($event)"
                [disabled]="data.isFetchingData"
                [multiple]="true">
                @for (
                  option of data.usersFilterOptions | terraLazyOptions: 'item' : { findObjectByProperty: true };
                  track option.item._id
                ) {
                  <terra-option [value]="option.item">
                    <ng-container *terraOptionPrefix>
                      @if (option.item._id !== 'all') {
                        <terra-avatar
                          [src]="option.item.metadata?.picture?.url"
                          [initials]="option.item | userInitials" />
                      }
                    </ng-container>
                    {{ option.item._id === 'all' ? 'All' : (option.item | displayNameOrEmail) }}
                  </terra-option>
                }
              </terra-quick-filter>
            }
            @if (data.options?.issuesTypeFilter) {
              <terra-quick-filter
                key="Type"
                data-cy="filters-toolbar_issues-type-select"
                [ngModel]="data.issuesArchiveTypeFilter"
                (selectionChange)="selectIssuesArchiveType($event)"
                [disabled]="data.isFetchingData">
                <terra-option value="all">All</terra-option>
                <terra-option [value]="IntervalCode.shortTerm">{{ data.language?.issue?.shortTerm }}</terra-option>
                <terra-option [value]="IntervalCode.longTerm">{{ data.language?.issue?.longTerm }}</terra-option>
              </terra-quick-filter>
            }
            @if (data.options?.rockStatusDropdown) {
              <terra-quick-filter
                [ngModel]="data.selectedRockFilter"
                (selectionChange)="filterService.setRockStatusFilter($event)"
                data-cy="filters-toolbar_rock-statuses-dropdown"
                key="Status">
                <terra-option value="all">All</terra-option>
                @for (
                  rockStatus of !data.allowedRocksDraftStatus
                    ? rockStatusService.filterBarStatuses
                    : rockStatusService.filterBarStatusesWithDraft;
                  track rockStatus.code
                ) {
                  <terra-option attr.data-cy="filters_toolbar-{{ rockStatus.label }}" [value]="rockStatus.code">
                    {{ rockStatus.label }}
                  </terra-option>
                }
              </terra-quick-filter>
            }
            @if (data.options?.masteryStatusDropdown) {
              <terra-quick-filter
                key="Status"
                data-cy="filter-toolbar_mastery-status_dropdown"
                (selectionChange)="filterService.setMasteryStatusFilter($event)"
                [ngModel]="data.selectedMasteryStatus"
                [disabled]="data.isFetchingData">
                <terra-option data-cy="filter-toolbar_mastery-status_all" [value]="MasteryFilterStatus.All"
                  >All</terra-option
                >
                <terra-option data-cy="filter-toolbar_mastery-status_mastered" [value]="MasteryFilterStatus.Mastered"
                  >Mastered</terra-option
                >
                <terra-option
                  data-cy="filter-toolbar_mastery-status_not-mastered"
                  [value]="MasteryFilterStatus.NotMastered"
                  >Not Mastered</terra-option
                >
              </terra-quick-filter>
            }
            @if (data.options?.archiveToggle && !data.isHeadlinesTrashView && !data.isIssuesTrashView) {
              <terra-switch
                attr.data-cy="filters-toolbar_archived-toggle-{{ data.showArchived }}"
                class="archive-toggle"
                [disabled]="(spinnerService.primary$ | async) || data.isFetchingData"
                [ngModel]="data.showArchived"
                (change)="this.filterService.onArchiveToggleClicked($event)">
                Archive
              </terra-switch>
            }
            @if (data.options?.showPeopleWithoutRocksToggle && !data.showArchived) {
              <terra-switch
                data-cy="filters-toolbar_show-people-without-rocks"
                [disabled]="data.isFetchingData"
                [ngModel]="filterService.showPeopleWithoutRocks$ | async"
                (change)="filterService.toggleShowPeopleWithoutRocks($event)">
                Show people without {{ data.language?.rock?.items }}
              </terra-switch>
            }
            @if (data.options?.completeToggle) {
              <terra-switch
                attr.data-cy="filters-toolbar_complete-toggle-{{ data.showCompleted }}"
                class="complete-toggle"
                [disabled]="(spinnerService.primary$ | async) || data.isFetchingData"
                [ngModel]="data.showCompleted"
                (change)="this.filterService.onToggleComplete($event)">
                Completed
              </terra-switch>
            }
            <div class="fill-remaining-space hide-lt-md"></div>
            @if (data.options?.expandCollapse) {
              <button
                mat-icon-button
                (click)="filterService.expandAll$.next(null)"
                matTooltip="Expand All"
                matTooltipClass="ninety-tooltip"
                aria-label="Expand All"
                [disabled]="data.isFetchingData">
                <terra-icon icon="caret-down" />
              </button>
            }
            @if (data.options?.expandCollapse) {
              <button
                mat-icon-button
                (click)="filterService.collapseAll$.next(null)"
                matTooltip="Collapse All"
                matTooltipClass="ninety-tooltip"
                aria-label="Collapse All"
                [disabled]="data.isFetchingData">
                <terra-icon icon="caret-up" />
              </button>
            }
            @if (data.options?.zoomButtons) {
              <div class="zoom-buttons">
                <button
                  mat-icon-button
                  (click)="filterService.zoomOut()"
                  matTooltip="Zoom Out"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Zoom Out"
                  [disabled]="data.isFetchingData">
                  <terra-icon icon="zoom-out" />
                </button>
                <mat-label id="zoom-label" aria-label="Zoom Scale"
                  >{{ parsePercent(filterService.zoomScale$ | async) }}
                </mat-label>
                <button
                  mat-icon-button
                  (click)="filterService.zoomIn()"
                  matTooltip="Zoom In"
                  aria-label="Zoom In"
                  [disabled]="data.isFetchingData">
                  <terra-icon icon="zoom-in" />
                </button>
                <button
                  mat-icon-button
                  (click)="filterService.zoomReset()"
                  matTooltip="Reset Zoom"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Reset Zoom"
                  [disabled]="data.isFetchingData">
                  <terra-icon icon="zoom-reset" />
                </button>
              </div>
            }
            <!-- todo - is helpful check needed?  helpful is always owner -->
            @if (
              data.company?.settings?.customVto &&
              data.options?.vtoGrid &&
              data.isSlt &&
              (data.isManagerOrAbove || (isHelpful$ | ngrxPush)) &&
              !data.archivedVto
            ) {
              <div class="hide-lt-md">
                <ninety-grid-layout-toolbar-buttons
                  [layoutModeActive]="data.options?.gridLayoutOptions"
                  [layoutModeDisabled]="spinnerService.primary$ | async">
                </ninety-grid-layout-toolbar-buttons>
              </div>
            }
            <!-- Edit Layout Actions -->
            @if (data.options?.editLayoutBtn) {
              <ninety-layout-actions-group
                data-cy="filters-toolbar_actions-button"
                [isFetching]="data.isFetchingData"></ninety-layout-actions-group>
            }
            <!-- Refresh Button -->
            @if (
              data.options?.refreshButton &&
              !data.options?.rocksMoreActionsBtn &&
              !data.options?.issuesMoreActionsBtn &&
              !data.options?.todosMoreActionsBtn &&
              !data.options?.headlinesMoreActionsBtn
            ) {
              <button
                data-cy="filters-toolbar_refreshButton"
                mat-icon-button
                data-cy="filters-toolbar_refresh-button"
                data-product="filters-toolbar__refresh-button"
                (click)="filterService.onRefresh()"
                [matTooltip]="'Refresh ' + (pageTitle$ | async)"
                matTooltipClass="ninety-tooltip"
                aria-label="Refresh"
                [disabled]="data.isFetchingData">
                <terra-icon icon="refresh" />
              </button>
            }
            <!-- Quarterly Export Button -->
            @if (!!(printOrDownloadFeature$ | ngrxPush)) {
              @if (data.options?.quarterlyExportBtn) {
                <button
                  mat-icon-button
                  (click)="filterService.onDownloadQuarterlyExport()"
                  matTooltip="Download Quarterly Export"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Download Quarterly Export"
                  [disabled]="data.isFetchingData || data.selectedTeam?._id === 'all'">
                  <terra-icon icon="data" />
                </button>
              }
            } @else {
              @if (data.options?.quarterlyExportBtn) {
                <ninety-button
                  class="no-background-when-disabled"
                  filled
                  primary
                  [disabled]="true"
                  [ninetyCmPopoverTrigger]="cmPopoverQuarterlyExport"
                  [ninetyCmPopoverEnabled]="true">
                  <terra-icon icon="data" size="20" />
                </ninety-button>
              }
            }
            <!-- Forecasting Scorecard Button -->
            @if (data.options?.showForecastingBtn && data.isManagerOrAbove) {
              <button
                mat-icon-button
                (click)="filterService.onGoalForecasting()"
                [disabled]="data.isFetchingData"
                data-product="filters-toolbar__goal-forecast-button"
                matTooltip="{{ data.language?.measurable?.goal }} Forecasting"
                matTooltipClass="ninety-tooltip"
                attr.aria-label="{{ data.language?.measurable?.goal }} Forecasting">
                <terra-icon icon="chart-bar" />
              </button>
            }
            <!-- Print PDF Button -->
            @if (!!(printOrDownloadFeature$ | ngrxPush)) {
              @if (
                data.options?.printToPdfBtn &&
                !data.options?.rocksMoreActionsBtn &&
                !data.options?.issuesMoreActionsBtn &&
                !data.options?.todosMoreActionsBtn &&
                !data.options?.headlinesMoreActionsBtn
              ) {
                <button
                  data-cy="filters-toolbar_print-to-pdf-button"
                  mat-icon-button
                  (click)="filterService.onPrintPdf()"
                  [disabled]="data.isFetchingData"
                  class="pdf-btn"
                  [matTooltip]="data.options?.printToPdfBtnTooltip"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Print to PDF">
                  <terra-icon icon="file-pdf" />
                </button>
              }
            } @else {
              @if (
                data.options?.printToPdfBtn &&
                !data.options?.rocksMoreActionsBtn &&
                !data.options?.issuesMoreActionsBtn &&
                !data.options?.todosMoreActionsBtn &&
                !data.options?.headlinesMoreActionsBtn
              ) {
                <ninety-button
                  filled
                  primary
                  [disabled]="true"
                  class="no-background-when-disabled"
                  [ninetyCmPopoverTrigger]="cmPopoverPrint"
                  [ninetyCmPopoverEnabled]="true">
                  <terra-icon icon="file-pdf" size="20" />
                </ninety-button>
              }
            }
            <!-- Download Excel Button -->
            @if (
              data.options?.excelExportType &&
              !data.options?.rocksMoreActionsBtn &&
              !data.options?.issuesMoreActionsBtn &&
              !data.options?.todosMoreActionsBtn &&
              !data.options?.headlinesMoreActionsBtn &&
              (data.options?.excelExportType === ExcelExportType.teamTodo ||
                data.options?.excelExportType === ExcelExportType.teamHeadlines ||
                (data.excelDownloadBatch2FeatureFlag &&
                  (data.options?.excelExportType === ExcelExportType.issues ||
                    data.options?.excelExportType === ExcelExportType.personalTodo ||
                    data.options?.excelExportType === ExcelExportType.rocksMilestones)))
            ) {
              <button
                mat-icon-button
                (click)="filterService.onCreateExcel(data.options.excelExportType)"
                [disabled]="data.isFetchingData"
                class="pdf-btn"
                matTooltip="Download Excel"
                matTooltipClass="ninety-tooltip"
                aria-label="Download Excel">
                <terra-icon icon="download" />
              </button>
            }
            <!-- Download Button -->
            @if (data.options?.downloadCsvBtn) {
              <button
                mat-icon-button
                (click)="filterService.onDownloadCsv()"
                matTooltip="Download XLS"
                data-product="filters-toolbar__download-xls-button"
                matTooltipClass="ninety-tooltip"
                aria-label="Download XLS"
                [disabled]="data.isFetchingData">
                <terra-icon icon="download" />
              </button>
            }
            <!-- Archive-All Button -->
            @if (
              data.options?.archiveAllBtn &&
              !data.showArchived &&
              data.isManagerOrAbove &&
              !data.options?.rocksMoreActionsBtn &&
              !data.options?.issuesMoreActionsBtn &&
              !data.options?.todosMoreActionsBtn &&
              !data.options?.headlinesMoreActionsBtn
            ) {
              <button
                data-cy="filters-toolbar_archive-all-completed-button"
                mat-icon-button
                (click)="filterService.onArchiveCompleted()"
                [disabled]="data.isFetchingData"
                matTooltip="Archive all completed"
                matTooltipClass="ninety-tooltip"
                aria-label="Archive all completed">
                <terra-icon icon="archive" />
              </button>
            }
            @if (data.options?.endQuarterBtn && data.isManagerOrAbove && !data.options?.rocksMoreActionsBtn) {
              <button
                data-cy="filters-toolbar_end_of_quarter-button"
                mat-icon-button
                (click)="filterService.onEndOfQuarter()"
                [disabled]="data.isFetchingData"
                matTooltip="End Quarter"
                matTooltipClass="ninety-tooltip"
                aria-label="End Quarter">
                <terra-icon icon="map-trifold" />
              </button>
            }
            <!-- More Actions Button (for meeting context, similar to rocks-page) -->
            @if (data.options?.rocksMoreActionsBtn) {
              @if (
                data.options?.archiveAllBtn && !data.showArchived && data.isManagerOrAbove && data.hasCompletedRocks
              ) {
                <button
                  mat-icon-button
                  data-cy="rocks-header-archive-all-completed"
                  matTooltip="Archive all completed"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Archive all completed"
                  [disabled]="data.isFetchingData"
                  (click)="filterService.onArchiveCompleted()">
                  <terra-icon icon="archive" />
                </button>
              }
              @if (data.options?.refreshButton) {
                <button
                  mat-icon-button
                  data-cy="rocks-header-refresh"
                  matTooltip="Refresh"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Refresh"
                  [disabled]="data.isFetchingData"
                  (click)="filterService.onRefresh()">
                  <terra-icon icon="refresh" />
                </button>
              }
              <div class="more-actions-button">
                <button
                  mat-icon-button
                  data-cy="rocks-header-more-actions"
                  [matMenuTriggerFor]="rockMenuActions"
                  matTooltip="More actions"
                  matTooltipClass="ninety-tooltip"
                  aria-label="More actions">
                  <terra-icon icon="more" />
                </button>
                <mat-menu #rockMenuActions="matMenu" xPosition="before" class="more-actions-button">
                  <!-- Print PDF Button -->
                  @if (!!(printOrDownloadFeature$ | ngrxPush)) {
                    @if (data.options?.printToPdfBtn) {
                      <button
                        mat-menu-item
                        data-cy="filters-toolbar_print-to-pdf-button"
                        (click)="filterService.onPrintPdf()"
                        [disabled]="data.isFetchingData"
                        class="pdf-btn"
                        matTooltip="Print to PDF"
                        matTooltipClass="ninety-tooltip"
                        aria-label="Print to PDF">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  } @else {
                    @if (data.options?.printToPdfBtn) {
                      <button
                        mat-menu-item
                        [disabled]="true"
                        class="pdf-btn"
                        matTooltip="Upgrade required"
                        matTooltipClass="ninety-tooltip"
                        aria-label="Print to PDF - Upgrade required">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  }
                  <!-- Download Excel Button -->
                  @if (
                    data.options?.excelExportType &&
                    (data.options?.excelExportType === ExcelExportType.teamTodo ||
                      data.options?.excelExportType === ExcelExportType.teamHeadlines ||
                      (data.excelDownloadBatch2FeatureFlag &&
                        (data.options?.excelExportType === ExcelExportType.issues ||
                          data.options?.excelExportType === ExcelExportType.personalTodo ||
                          data.options?.excelExportType === ExcelExportType.rocksMilestones)))
                  ) {
                    <button
                      mat-menu-item
                      (click)="filterService.onCreateExcel(data.options.excelExportType)"
                      [disabled]="data.isFetchingData"
                      class="pdf-btn"
                      matTooltip="Download Excel"
                      matTooltipClass="ninety-tooltip"
                      aria-label="Download Excel">
                      <terra-icon icon="download" />Download Excel
                    </button>
                  }
                  @if (data.options?.endQuarterBtn && data.isManagerOrAbove) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_end_of_quarter-button"
                      (click)="filterService.onEndOfQuarter()"
                      [disabled]="data.isFetchingData"
                      matTooltip="End Quarter"
                      matTooltipClass="ninety-tooltip"
                      aria-label="End Quarter">
                      <terra-icon icon="map-trifold" />End Quarter
                    </button>
                  }
                </mat-menu>
              </div>
            }
            <!-- Issues More Actions -->
            @if (data.options?.issuesMoreActionsBtn) {
              @if (
                data.options?.archiveAllBtn &&
                !data.showArchived &&
                !data.isIssuesTrashView &&
                data.isManagerOrAbove &&
                data.hasCompletedIssues
              ) {
                <button
                  data-cy="filters-toolbar_issues-archive-all-completed"
                  mat-icon-button
                  (click)="filterService.onArchiveCompleted()"
                  [disabled]="data.isFetchingData"
                  matTooltip="Archive all completed"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Archive all completed">
                  <terra-icon icon="archive" />
                </button>
              }
              @if (data.options?.refreshButton) {
                <button
                  data-cy="filters-toolbar_issues-refresh"
                  mat-icon-button
                  (click)="filterService.onRefresh()"
                  [matTooltip]="'Refresh ' + (pageTitle$ | async)"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Refresh"
                  [disabled]="data.isFetchingData">
                  <terra-icon icon="refresh" />
                </button>
              }
              <div class="more-actions-button">
                <button
                  data-cy="filters-toolbar_issues-more-actions"
                  mat-icon-button
                  [matMenuTriggerFor]="issueMenuActions"
                  matTooltip="More actions"
                  matTooltipClass="ninety-tooltip"
                  aria-label="More actions">
                  <terra-icon icon="more" />
                </button>
                <mat-menu #issueMenuActions="matMenu" xPosition="before" class="more-actions-button">
                  @if (data.options?.settingsBtn && data.isManagerOrAbove && !data.isIssuesTrashView) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_issues-settings"
                      (click)="filterService.onSettings()"
                      [disabled]="spinnerService.primary$ | async"
                      aria-label="Open Settings">
                      <terra-icon icon="settings" />Settings
                    </button>
                  }
                  @if (!!(printOrDownloadFeature$ | ngrxPush)) {
                    @if (data.options?.printToPdfBtn) {
                      <button
                        mat-menu-item
                        data-cy="filters-toolbar_issues-print-to-pdf"
                        (click)="filterService.onPrintPdf()"
                        [disabled]="data.isFetchingData"
                        aria-label="Print to PDF">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  } @else {
                    @if (data.options?.printToPdfBtn) {
                      <button mat-menu-item [disabled]="true" aria-label="Print to PDF - Upgrade required">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  }
                  @if (
                    data.options?.excelExportType &&
                    (data.options?.excelExportType === ExcelExportType.teamTodo ||
                      data.options?.excelExportType === ExcelExportType.teamHeadlines ||
                      (data.excelDownloadBatch2FeatureFlag &&
                        (data.options?.excelExportType === ExcelExportType.issues ||
                          data.options?.excelExportType === ExcelExportType.personalTodo ||
                          data.options?.excelExportType === ExcelExportType.rocksMilestones)))
                  ) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_issues-download-excel"
                      (click)="filterService.onCreateExcel(data.options.excelExportType)"
                      [disabled]="data.isFetchingData"
                      aria-label="Download Excel">
                      <terra-icon icon="download" />Download Excel
                    </button>
                  }
                  <!-- Trash is a standalone-issues-page feature; never offered inside a meeting (incl. View Tools). -->
                  @if (!data.isObserver && !data.isIssuesTrashView && !data.isMeetingContext) {
                    <button
                      mat-menu-item
                      (click)="viewIssuesTrash()"
                      [disabled]="data.isFetchingData"
                      aria-label="View Trash">
                      <terra-icon icon="delete" />View Trash
                    </button>
                  }
                </mat-menu>
              </div>
            }
            <!-- Todos More Actions -->
            @if (data.options?.todosMoreActionsBtn) {
              @if (
                data.options?.archiveAllBtn && !data.showArchived && data.isManagerOrAbove && data.hasCompletedTodos
              ) {
                <button
                  data-cy="filters-toolbar_todos-archive-all-completed"
                  mat-icon-button
                  (click)="filterService.onArchiveCompleted()"
                  [disabled]="data.isFetchingData"
                  matTooltip="Archive all completed"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Archive all completed">
                  <terra-icon icon="archive" />
                </button>
              }
              @if (data.options?.refreshButton) {
                <button
                  data-cy="filters-toolbar_todos-refresh"
                  mat-icon-button
                  (click)="filterService.onRefresh()"
                  [matTooltip]="'Refresh ' + (pageTitle$ | async)"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Refresh"
                  [disabled]="data.isFetchingData">
                  <terra-icon icon="refresh" />
                </button>
              }
              <div class="more-actions-button">
                <button
                  data-cy="filters-toolbar_todos-more-actions"
                  mat-icon-button
                  [matMenuTriggerFor]="todoMenuActions"
                  matTooltip="More actions"
                  matTooltipClass="ninety-tooltip"
                  aria-label="More actions">
                  <terra-icon icon="more" />
                </button>
                <mat-menu #todoMenuActions="matMenu" xPosition="before" class="more-actions-button">
                  @if (!!(printOrDownloadFeature$ | ngrxPush)) {
                    @if (data.options?.printToPdfBtn) {
                      <button
                        mat-menu-item
                        data-cy="filters-toolbar_todos-print-to-pdf"
                        (click)="filterService.onPrintPdf()"
                        [disabled]="data.isFetchingData"
                        aria-label="Print to PDF">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  } @else {
                    @if (data.options?.printToPdfBtn) {
                      <button mat-menu-item [disabled]="true" aria-label="Print to PDF - Upgrade required">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  }
                  @if (
                    data.options?.excelExportType &&
                    (data.options?.excelExportType === ExcelExportType.teamTodo ||
                      data.options?.excelExportType === ExcelExportType.teamHeadlines ||
                      (data.excelDownloadBatch2FeatureFlag &&
                        (data.options?.excelExportType === ExcelExportType.issues ||
                          data.options?.excelExportType === ExcelExportType.personalTodo ||
                          data.options?.excelExportType === ExcelExportType.rocksMilestones)))
                  ) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_todos-download-excel"
                      (click)="filterService.onCreateExcel(data.options.excelExportType)"
                      [disabled]="data.isFetchingData"
                      aria-label="Download Excel">
                      <terra-icon icon="download" />Download Excel
                    </button>
                  }
                  @if (
                    data.isTodosTrashcanEnabled &&
                    !data.isTodosTrashView &&
                    !data.isObserver &&
                    data.options?.excelExportType === ExcelExportType.teamTodo
                  ) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_todos-view-trash-button"
                      (click)="viewTodosTrash()"
                      [disabled]="data.isFetchingData"
                      aria-label="View Trash">
                      <terra-icon icon="delete" />View Trash
                    </button>
                  }
                </mat-menu>
              </div>
            }
            <!-- Headlines More Actions -->
            @if (data.options?.headlinesMoreActionsBtn) {
              @if (
                data.options?.archiveAllBtn &&
                !data.showArchived &&
                !data.isHeadlinesTrashView &&
                data.isManagerOrAbove &&
                data.hasCompletedHeadlines
              ) {
                <button
                  data-cy="filters-toolbar_headlines-archive-all-completed"
                  mat-icon-button
                  (click)="filterService.onArchiveCompleted()"
                  [disabled]="data.isFetchingData"
                  matTooltip="Archive all completed"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Archive all completed">
                  <terra-icon icon="archive" />
                </button>
              }
              @if (data.options?.refreshButton) {
                <button
                  data-cy="filters-toolbar_headlines-refresh"
                  mat-icon-button
                  (click)="filterService.onRefresh()"
                  matTooltip="Refresh"
                  matTooltipClass="ninety-tooltip"
                  aria-label="Refresh"
                  [disabled]="data.isFetchingData">
                  <terra-icon icon="refresh" />
                </button>
              }
              <div class="more-actions-button">
                <button
                  data-cy="filters-toolbar_headlines-more-actions"
                  mat-icon-button
                  [matMenuTriggerFor]="headlineMenuActions"
                  matTooltip="More actions"
                  matTooltipClass="ninety-tooltip"
                  aria-label="More actions">
                  <terra-icon icon="more" />
                </button>
                <mat-menu #headlineMenuActions="matMenu" xPosition="before" class="more-actions-button">
                  @if (!!(printOrDownloadFeature$ | ngrxPush)) {
                    @if (data.options?.printToPdfBtn) {
                      <button
                        mat-menu-item
                        data-cy="filters-toolbar_headlines-print-to-pdf"
                        (click)="filterService.onPrintPdf()"
                        [disabled]="data.isFetchingData"
                        aria-label="Print to PDF">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  } @else {
                    @if (data.options?.printToPdfBtn) {
                      <button mat-menu-item [disabled]="true" aria-label="Print to PDF - Upgrade required">
                        <terra-icon icon="file-pdf" />Print to PDF
                      </button>
                    }
                  }
                  @if (
                    !data.isHeadlinesTrashView &&
                    data.options?.excelExportType &&
                    (data.options?.excelExportType === ExcelExportType.teamTodo ||
                      data.options?.excelExportType === ExcelExportType.teamHeadlines ||
                      (data.excelDownloadBatch2FeatureFlag &&
                        (data.options?.excelExportType === ExcelExportType.issues ||
                          data.options?.excelExportType === ExcelExportType.personalTodo ||
                          data.options?.excelExportType === ExcelExportType.rocksMilestones)))
                  ) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_headlines-download-excel"
                      (click)="filterService.onCreateExcel(data.options.excelExportType)"
                      [disabled]="data.isFetchingData"
                      aria-label="Download Excel">
                      <terra-icon icon="download" />Download Excel
                    </button>
                  }
                  @if (
                    data.isHeadlinesTrashView &&
                    data.excelDownloadBatch2FeatureFlag &&
                    data.options?.excelExportType === ExcelExportType.teamHeadlines
                  ) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_headlines-download-excel-trash"
                      (click)="filterService.onCreateExcel(data.options.excelExportType)"
                      [disabled]="data.isFetchingData"
                      aria-label="Download Excel">
                      <terra-icon icon="download" />Download Excel
                    </button>
                  }
                  @if (data.isHeadlinesTrashcanEnabled && !data.isObserver && !data.isHeadlinesTrashView) {
                    <button
                      mat-menu-item
                      data-cy="filters-toolbar_headlines-view-trash-button"
                      (click)="viewHeadlinesTrash()"
                      [disabled]="data.isFetchingData"
                      aria-label="View Trash">
                      <terra-icon icon="delete" />View Trash
                    </button>
                  }
                </mat-menu>
              </div>
            }
            <!-- Search box -->
            @if (data.options?.searchInput) {
              <terra-search-input
                data-cy="filters-toolbar_search-input-field"
                class="terrafy-search"
                [ngModel]="filterService.searchText$ | async"
                (ngModelChange)="filterService.setSearchText($event)"
                [placeholder]="'Search ' + (pageTitle$ | async) + '...'"
                aria-label="search filter" />
            }
            <!-- Settings Button -->
            @if (data.options?.settingsBtn && data.isManagerOrAbove && !data.options?.issuesMoreActionsBtn) {
              <button
                data-cy="filters-toolbar_settings-button"
                mat-icon-button
                (click)="filterService.onSettings()"
                matTooltipClass="ninety-tooltip"
                [matTooltip]="'Open ' + (pageTitle$ | async) + ' Settings'"
                aria-label="Open Settings"
                [disabled]="spinnerService.primary$ | async">
                <terra-icon icon="settings" />
              </button>
            }
            <!-- Settings Button -->
            @if (data.options?.feedbackSettingsBtn && data.isAdminOrOwner) {
              <button
                mat-icon-button
                data-cy="filters-toolbar_settings-button"
                class="settings-btn"
                (click)="auxRouterService.closeDetailBeforeNavigate(activatedRoute, ['1-on-1/settings'])">
                <terra-icon
                  icon="settings"
                  [matTooltip]="'Open ' + data.language?.feedback?.route + ' Settings'"
                  matTooltipPosition="above"
                  matTooltipClass="ninety-tooltip" />
              </button>
            }
          </div>
        </div>
      }
    </mat-toolbar>
  } @else if (meetingNavCollapsed()) {
    <div class="meeting-nav-expand-rail">
      <button
        type="button"
        class="meeting-nav-expand-toggle brand-colored"
        [class.brand-light]="data.brandIsLight"
        aria-label="Expand meeting navigation"
        (click)="expandMeetingNav()"
        [ninetyTooltip]="'Expand'"
        tpPlacement="right">
        <terra-icon icon="caret-right" variant="bold" size="12" />
      </button>
    </div>
  }

  <!-- cm popover for quarterly export and print not available -->
  <ninety-cm-popover #cmPopoverQuarterlyExport>
    <div headline>Export Your Key Business Data in One Download</div>
    <div description>
      Export your {{ data.language?.rock?.items }} , {{ data.language?.scorecard?.item }},
      {{ data.language?.vto?.vision }}, and {{ data.language?.acChart?.chart }} all in one easy-to-share download. Keep
      your team aware and aligned with key information housed in a single, comprehensive file.
    </div>
    <button ninety-cm-button (click)="onExplorePlansClick()">
      <terra-icon icon="lightning" variant="fill" size="40" />
      Explore Essentials Plan
    </button>
  </ninety-cm-popover>

  <ninety-cm-popover #cmPopoverPrint>
    <div headline>Make Your {{ data.language?.vto?.vision }} Easily Accessible</div>
    <div description>
      Print your {{ data.language?.vto?.vision }} and {{ data.language?.vto?.traction }} as a PDF for easy sharing and
      reference. Ensure everyone stays aligned on your company's purpose, strategy, and objectives.
    </div>
    <button ninety-cm-button (click)="onExplorePlansClick()">
      <terra-icon icon="lightning" variant="fill" size="40" />
      Explore Essentials Plan
    </button>
  </ninety-cm-popover>
</ng-container>
